import { func, object, oneOfType, string } from 'prop-types'

export default oneOfType([func, object, string])
